import PropTypes from 'prop-types';

export type AvatarSizes = 'small' | 'medium' | 'large';

export const AVATAR_SMALL: AvatarSizes = 'small';
export const AVATAR_MEDIUM: AvatarSizes = 'medium';
export const AVATAR_LARGE: AvatarSizes = 'large';

export const avatarSizePropTypes = PropTypes.oneOf([AVATAR_SMALL, AVATAR_MEDIUM, AVATAR_LARGE]);
